import { processRequest } from '../../services/Api';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { resultDetailsActionTypes } from './Constants';
import * as resultDetailsActions from './Actions';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			resultDetailsActionTypes.GET_RESULT_DETAILS_REQUEST,
			handleResultDetailsRequest,
		),
		yield takeLatest(
			resultDetailsActionTypes.GET_EXERCISE_TYPES_REQUEST,
			handleExerciseTypesRequest,
		),
	]);
}

export function* handleResultDetailsRequest({ payload }) {
	try {
		const { id, query } = payload || {};
		const { data } = yield call(processRequest, `public/results/${id}`, 'GET', query);

		yield put(resultDetailsActions.getResultDetailsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(resultDetailsActions.getResultDetailsError());
	}
}

export function* handleExerciseTypesRequest() {
	try {
		const { data } = yield call(processRequest, 'exercises/types');

		yield put(resultDetailsActions.getExerciseTypesSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(resultDetailsActions.getExerciseTypesError());
	}
}
